import { useMemo, useRef, useState } from 'react'
import { AnimatePresence, useInView } from 'framer-motion'

import { Container } from 'components/container'
import { Layout } from 'components/layout'
import { useAppContext } from 'context/app-context'
import { WordCard } from './word/card'
import { ShareTile } from './word/share'
import { SORTING_OPTIONS, Sorting } from './filters/sorting'
import { Filters } from './filters/filters'
import { Search } from './filters/search'
import { Share } from './share'
import {
  Backdrop,
  FiltersWrapper,
  Intro,
  List,
  ListContainer,
  Logo,
  LogoContainer,
  NoResults,
  Title,
} from './styled'

export const Home = () => {
  const { data, texts } = useAppContext()
  const listRef = useRef(null)
  const isInView = useInView(listRef, {
    once: true,
    margin: '0px 0px -50% 0px',
  })
  const [activeFilter, setActiveFilter] = useState('')
  const [search, setSearch] = useState('')
  const [blob, setBlob] = useState<Blob | null>(null)
  const [shareIndex, setShareIndex] = useState(-1)
  const [reversedIndex, setReversedIndex] = useState({
    current: -1,
    previous: -1,
  })

  const [sorting, setSorting] = useState({
    key: SORTING_OPTIONS[0].key as (typeof SORTING_OPTIONS)[number]['key'],
    ord: 'asc' as 'asc' | 'desc',
  })

  const filteredData = useMemo(() => {
    const d = (data || [])
      ?.filter(
        d =>
          !!d.tatar &&
          (!activeFilter || d?.category_possibly === activeFilter) &&
          (!search ||
            d.tatar.includes(search) ||
            d.english.includes(search) ||
            d.russian.includes(search))
      )
      .sort(SORTING_OPTIONS.find(s => s.key === sorting.key)?.sortFunc)
    return sorting.ord === 'asc' ? d : d.slice().reverse()
  }, [activeFilter, data, search, sorting.key, sorting.ord])

  return (
    <Layout>
      <Container>
        <Share />

        <LogoContainer>
          <a href="/">
            <Logo />
          </a>
        </LogoContainer>

        <Title>{texts?.title}</Title>
        <Intro>
          {texts?.intro.split('\n\n').map((part, index) => (
            <p key={index} dangerouslySetInnerHTML={{ __html: part }} />
          ))}
        </Intro>

        <p>
          <img
            src=""
            alt=""
            style={{ display: 'block', width: '30rem' }}
            id="output"
          />
        </p>

        <Sorting sorting={sorting} onChange={setSorting} />
        <FiltersWrapper>
          <Filters
            words={data}
            activeFilter={activeFilter}
            onChange={setActiveFilter}
          />
          <Search value={search} onChange={setSearch} />
        </FiltersWrapper>

        <ListContainer>
          {!!search && !filteredData.length && (
            <NoResults>Андый сүз табылмады.</NoResults>
          )}
          <List layout key={data?.length} ref={listRef}>
            <AnimatePresence>
              {filteredData.map((word, index) => (
                <WordCard
                  key={word.tatar}
                  i={index}
                  word={word}
                  isInView={isInView}
                  isPrevious={index === reversedIndex.previous}
                  isReversed={index === reversedIndex.current}
                  onClose={() =>
                    setReversedIndex(v => ({
                      current: -1,
                      previous: v.current,
                    }))
                  }
                  onReverse={() =>
                    setReversedIndex({ current: index, previous: -1 })
                  }
                  blob={blob}
                  onShare={() => setShareIndex(index)}
                />
              ))}
            </AnimatePresence>
          </List>
          <Backdrop
            $isVisible={reversedIndex.current >= 0}
            onClick={() =>
              setReversedIndex(v => ({ current: -1, previous: v.current }))
            }
          />
        </ListContainer>

        {shareIndex >= 0 && (
          <ShareTile
            key={shareIndex}
            word={filteredData[shareIndex]}
            onClose={setBlob}
          />
        )}
      </Container>
    </Layout>
  )
}
